/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Attendance_SavedInputs */

const en_interview_attendance_saved = /** @type {(inputs: Interview_Attendance_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation saved`)
};

const de_interview_attendance_saved = /** @type {(inputs: Interview_Attendance_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigung gespeichert`)
};

/**
* | output |
* | --- |
* | "Confirmation saved" |
*
* @param {Interview_Attendance_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_attendance_saved = /** @type {((inputs?: Interview_Attendance_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Attendance_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_attendance_saved(inputs)
	return en_interview_attendance_saved(inputs)
});